import { Feature, isAvailable } from 'App/services/FeatureHelperStandalone';

type FieldWithCategories = { categories?: { id: number }[] };
type RowProduct = { category?: { id: number } | null } | null;

export const isHiddenByFieldCategories = (field: FieldWithCategories | undefined, product?: RowProduct): boolean => {
	if (!isAvailable(Feature.ROW_CUSTOM_VISIBILITY) || !field?.categories?.length) {
		return false;
	}

	const categoryId = product?.category?.id;
	return !categoryId || !field.categories.some(category => category.id === categoryId);
};

/** For the read sites that only hold the field id, not the field definition. */
export const isFieldIdHiddenByFieldCategories = (
	fieldId: number,
	fields: (FieldWithCategories & { id: number })[],
	product?: RowProduct
): boolean => {
	if (!isAvailable(Feature.ROW_CUSTOM_VISIBILITY)) {
		return false;
	}

	return isHiddenByFieldCategories(
		fields.find(field => field.id === fieldId),
		product
	);
};
